namespace GeniuzPOS.Lookups {
    export interface LookupSupplierRow {
        Id?: number;
        SupplId?: string;
        SupplName?: string;
        SupplType?: number;
        ContactName?: string;
        SupplAddress?: string;
        SupplRegName?: string;
        SupplRegAddress?: string;
        SupplTaxId?: string;
        ConsignFg?: number;
        ConsignGp?: number;
        SupplierShortName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace LookupSupplierRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SupplId';
        export const localTextPrefix = 'Lookups.LookupSupplier';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SupplId = "SupplId",
            SupplName = "SupplName",
            SupplType = "SupplType",
            ContactName = "ContactName",
            SupplAddress = "SupplAddress",
            SupplRegName = "SupplRegName",
            SupplRegAddress = "SupplRegAddress",
            SupplTaxId = "SupplTaxId",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            SupplierShortName = "SupplierShortName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
